<template>
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.user_nickname"
                        placeholder="请输入代理商名称"
                    ></el-input>
                </el-form-item>
              <el-form-item>
              <el-input
                  size
                  clearable
                  v-model="searchForm.phone"
                  placeholder="请输入代理商账号"
              ></el-input>
              </el-form-item>
			  <el-form-item>
			  <el-input
			      size
			      clearable
			      v-model="searchForm.agent_no"
			      placeholder="请输入代理商编号"
			  ></el-input>
			  </el-form-item>
			  <el-form-item>
			  <el-input
			      size
			      clearable
			      v-model="searchForm.person_nick_name"
			      placeholder="请输入归属销售"
			  ></el-input>
			  </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="添加开始日期"
                        end-placeholder="添加结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                    
                </el-form-item>
                <el-form-item>
                    <el-button style="font-size: 12px;margin-left:20px" size="medium" type="primary" icon="el-icon-download"
                    	:loading="downLoading" @click="handleDownLoad(searchForm)">导出数据</el-button>
                </el-form-item>
                
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div  style="margin-bottom:20px">
				<el-button size="medium" type="primary"  style="font-size: 12px;"
					@click="addAgentStateClick">添加代理</el-button>
			</div>
            <el-table
                :data="agentList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 代理商名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_nick_name"
                    label="代理商名称"
                    min-width="120"
                ></el-table-column>
				<!-- 代理商账号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="user_phone"
				    label="代理商账号"
				    min-width="120"
				></el-table-column>
				<!-- 代理商编号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="agent_no"
				    label="代理商编号"
				    min-width="160"
				></el-table-column>
				<!-- 真实姓名 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="real_name"
				    label="真实姓名"
				    min-width="120"
				></el-table-column>
				<!-- 代理商层级 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="level"
				    label="代理商层级"
				    min-width="120"
				></el-table-column>
				<!-- 添加时间 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="create_time"
				    label="添加时间"
				    min-width="160"
				></el-table-column>
				<!-- 归属销售 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="person_nick_name"
				    label="归属销售"
				    min-width="120"
				></el-table-column>
				<!-- 销售手机号/账号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="mobile"
				    label="销售手机号/账号"
				    min-width="160"
				></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="100"
                >
                    <template slot-scope="scope">
                      <el-button style="color: #f00;"  @click="cellClick(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
		
		<el-dialog title="添加代理" :visible.sync="addAgentState" class="dialog">
		  <el-form  label-position="right" :model="addForm" ref="addForm" label-width="120px"  :rules="rules" >
		     <el-form-item label="归属销售:"  prop="person_id">
				<el-select filterable v-model="addForm.person_id" placeholder="请选择归属销售">
				  <el-option v-for="(item,index) in saleList" :key="item.nick_name" :label="item.nick_name" :value="item.id"></el-option>
				</el-select>
		      </el-form-item>
			  <el-form-item label="选择代理商:"  prop="user_ids">
				  <el-select multiple filterable v-model="addForm.user_ids" placeholder="请选择代理商">
				    <el-option v-for="(item,index) in agentAllList" :key="item.nickname" :label="item.nickname" :value="item.id"></el-option>
				  </el-select>		
			   </el-form-item>
			 
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addAgentState = false">取 消</el-button>
		    <el-button type="primary" @click="addSubmit()">确 定</el-button>
		  </div>
		</el-dialog>
		
    </div>
</template>

<script>
export default {
    name: "salePersonLinkAgent",
    data() {
        return {
            searchForm: {
                user_nickname: '',
                agent_no: '',
                phone: '',
				person_nick_name:'',
                start_time: '',
                end_time: '',
				limit:10,
				page: 1
            },
            downLoading:false,
			addAgentState:false,
			addForm:{
				user_ids:'',
				person_id:''
			},
			rules: {
				person_id: [{
					required: true,
					message: '请选择归属销售',
					trigger: 'change'
				}],
				user_ids: [{
					required: true,
					message: '请选择代理商',
					trigger: 'change'
				}],
			},
            rangeDate: '',
            agentList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
			saleList:[],
			agentAllList:[]
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
		this.getSalePersion()
		this.getAgentPersion()
    },
    methods: {
        handleDownLoad(params) { //导出
        	let reqData = {
        		type: 23,
        		value: JSON.stringify(params)
        	};
        
        	this.downLoading = true;
        	this.$api.post('export/add', reqData, res => {
        		if (res.code == 0) {
        			this.$message.success(res.msg);
        			this.downLoading = false;
        		} else {
        			this.$message.error(res.msg);
        			this.downLoading = false;
        		}
        
        	})
        },
		// 获取销售
		getSalePersion() {
			this.$api.post("sale/selSalePersonOpt", {}, res => {
			    let data = res.data;
			    this.saleList = res.data;
			})
		},
		// 获取代理销售
		getAgentPersion() {
			this.$api.post("sale/selAgentUserList", {}, res => {
			    let data = res.data;
			    this.agentAllList = res.data;
			})
		},
		
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("sale/selSalePersonUserList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.agentList = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
		cellClick(item){
			this.$confirm('确认删除？', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
				this.loading = true;
				let params = {
					id:item.id
				}
				this.$api.post("sale/delSalePersonUser", params, res => {
				    //渲染结束后取消加载
				    this.loading = false;
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.getData(this.searchForm);
						this.getAgentPersion()				   
					}else {
						this.$message.error(res.msg);
					}
				})
			
			}).catch(err=>{});
		},
		addAgentStateClick(){
			this.addForm.person_id = ''
			this.addForm.user_ids = ''
			this.addAgentState = true
		},
		//添加关联代理
		addSubmit(){
			console.log(JSON.stringify(this.addForm));
			this.$refs['addForm'].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.addForm.user_ids = this.addForm.user_ids.join(',')
					console.log(JSON.stringify(this.addForm));
					this.$api.post("sale/bindSalePersonUser", this.addForm, res => {
					    //渲染结束后取消加载
					    this.loading = false;
						if (res.code == 0) {
							this.addAgentState = false
							this.$message.success(res.msg);
							this.getData(this.searchForm);
							this.getAgentPersion()					   
						}else {
							this.$message.error(res.msg);
						}
					})
					
				}
				
			})
			
		}
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>